import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/inter-cyrillic-normal-aebf2ab4.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22inter%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0301,%20U+0400-045F,%20U+0490-0491,%20U+04B0-04B1,%20U+2116%22}]}],%22variableName%22:%22interCyrillic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'interCyrillic'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
